import { applyTheme } from '../lib/theme'

applyTheme()
document.querySelectorAll('[data-year]').forEach((e) => (e.textContent = String(new Date().getFullYear())))
